/**
 * Size the Ecwid admin iframe to the CP viewport and scroll inside the app.
 * autoheight:true makes the iframe as tall as the page, so position:fixed/sticky
 * headers scroll away with the parent — this keeps a real viewport instead.
 */
export function sizeEcwidIframe() {
  if (typeof window === 'undefined') return;
  if (typeof EcwidApp === 'undefined' || typeof EcwidApp.setSize !== 'function') {
    return;
  }

  let height = 900;
  try {
    const frame = window.frameElement;
    const slotH = frame?.parentElement?.clientHeight;
    if (slotH && slotH > 400) {
      height = Math.floor(slotH);
    } else {
      const avail = window.screen?.availHeight || window.innerHeight || 900;
      height = Math.max(640, Math.min(Math.round(avail * 0.8), 1200));
    }
  } catch {
    const avail = window.screen?.availHeight || 900;
    height = Math.max(640, Math.min(Math.round(avail * 0.8), 1200));
  }

  EcwidApp.setSize({ height });
}

export function initEcwidIframeViewport(appId) {
  if (typeof window === 'undefined' || window.self === window.top) return;

  document.documentElement.classList.add('ecwid-iframe');
  document.body.classList.add('ecwid-iframe');

  if (typeof EcwidApp === 'undefined') return;

  EcwidApp.init({
    app_id: appId,
    autoloadedflag: true,
    autoheight: false,
  });

  sizeEcwidIframe();
  window.setTimeout(sizeEcwidIframe, 250);
  window.setTimeout(sizeEcwidIframe, 1000);
  window.addEventListener('resize', sizeEcwidIframe);
}
